import { useTranslation } from "react-i18next";
import { Icon } from "@thetreep/ui";
import { routes } from "@routes";
import { useNavigate, useLocation, useMatch } from "react-router";

export function Stepper() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  // Définir les routes qui correspondent à chaque étape
  const stepRoutes = {
    search: [routes.EXCHANGE_SEARCH],
    select: [routes.EXCHANGE_RESULTS],
    recap: [routes.EXCHANGE_RECAP],
  };

  const steps = [
    {
      number: 1,
      label: t("steps.search"),
      route: routes.EXCHANGE_SEARCH,
      activeRoutes: stepRoutes.search,
    },
    {
      number: 2,
      label: t("steps.select"),
      route: routes.EXCHANGE_RESULTS,
      activeRoutes: stepRoutes.select,
    },
    {
      number: 3,
      label: t("steps.confirm"),
      route: routes.EXCHANGE_RECAP,
      activeRoutes: stepRoutes.recap,
    },
  ];

  const isExchangeResult = useMatch(routes.EXCHANGE_RESULTS);
  const showBackButton =
    location.pathname === routes.RESULTS || Boolean(isExchangeResult);

  return (
    <div className="fixed  z-[150] left-0 right-0  top-[113px] md:top-[161px] bg-light-blue-100 py-3 md:py-6 lg:px-12 xl:px-48">
      <div className="flex justify-around lg:justify-between items-center ">
        {showBackButton && (
          <div
            onClick={() =>
              isExchangeResult
                ? navigate(
                    routes.EXCHANGE_SEARCH.replace(
                      ":travelId",
                      isExchangeResult?.params.travelId ?? "",
                    ).replace(
                      ":journeyId",
                      isExchangeResult?.params.journeyId ?? "",
                    ),
                  )
                : navigate(routes.SEARCH + location.search)
            }
            className="cursor-pointer flex flex-col md:flex-row justify-between items-center min-h-[36px] md:min-h-0 md:gap-2"
          >
            <Icon src="arrow_left_line" size={18} />
            <div className="text-blue-strong text-xs md:text-base font-jakarta font-bold">
              {t("steps.back")}
            </div>
          </div>
        )}

        {steps.map((step) => {
          const isActive = step.activeRoutes.includes(location.pathname);

          return (
            <div
              key={step.number}
              className={`flex flex-col md:flex-row justify-between items-center min-h-[36px] md:min-h-0 md:gap-2 ${
                isActive ? "opacity-100" : "opacity-30"
              }`}
            >
              <div className="bg-blue-strong rounded-sm md:rounded-md w-4 h-4 md:w-6 md:h-6 text-white flex justify-center items-center text-xs md:text-base font-bold">
                {step.number}
              </div>
              <div className="text-blue-strong text-xs md:text-base font-jakarta font-bold">
                {step.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
